import "../../style/scss/App.scss";
import { DateTime } from "luxon";

export default function JobPostingListItem({ post, employmentTypes, onEdit }) {
  if (!post) return null;
  const id = post.ID || post.id;
  const employmentType = (employmentTypes || []).find(
    (et) => et.Key === post.EmploymentTypeID || et.Key === post.employmentTypeID
  );
  const killDate = post.KillDate || post.killDate;

  return (
    <button
      type="button"
      className="centered skillLink job-posting-list-item"
      data-testid={`job-posting-edit-${id}`}
      onClick={() => onEdit?.(id)}
    >
      <div className="Role mobilePanel">
        <span className="title">
          {post.Title || post.title}({post.PositionCount ?? post.positionCount ?? 1})
        </span>
        <span className="byline">{employmentType?.Value || ""}</span>
        <span className="rightText">
          {killDate ? DateTime.fromISO(killDate).toFormat("MM/yyyy") : ""}
        </span>
      </div>
    </button>
  );
}
